import * as angular from 'angular';
import * as _ from 'underscore';
import { IImgFileModel } from '../../../../../app.common/modules/common/directives/models';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { ProductsService } from '../../products.service';

interface IProductImage {
    id: string;
    url: string;
}

class ChoiceProductImagesComponent {
    public static $inject = ['$scope', '$q', 'productsService', 'popupService', 'notificationService', '$translate'];
    public currentImagesId: string[];
    public serverImagesId: string[];
    public callbackUpdate: () => void;
    public uploadedImages: IImgFileModel[] = null;
    public images: IProductImage[] = [];
    public waiting: boolean = false;
    public sortableOptions = {
        /*   update: ( event, ui )=> {
              console.log('sortableOptions update', ui);

          } */
    };
    public fileExtensions: string[] = ['png', 'gif', 'jpg', 'jpeg'];
    public imageInputId: number;

    constructor(
        private $scope: ng.IScope,
        private $q: ng.IQService,
        private productService: ProductsService,
        private popupService: PopupService,
        private notificationService: NotificationService,
        private $translate: angular.translate.ITranslateService
    ) {

        this.$scope.$watch('vm.currentImagesId', (n: any, o: any) => {
            if (n) {
                this.init();
            }
        }, true);

        this.$scope.$watch('vm.images', (n: any, o: any) => {
            if (n) {
                this.updateModel();
            }
        }, true);
    }

    public uploadImages = async () => {
        if (!this.uploadedImages) {
            return;
        }

        const failImages = _.reject(this.uploadedImages, this.emptyErrorImage);
        const validImages = _.filter(this.uploadedImages, this.emptyErrorImage);

        if (_.size(validImages) === 0) {
            this.showFail(failImages);
            this.uploadedImages = null;
            return;
        }

        this.notificationService.showWaitingMessage();
        this.waiting = true;

        const promises: Array<angular.IPromise<string>> = [];
        _.forEach(validImages, (image) => {
            promises.push(this.productService.uploadImage(image));
        });
        try {
            const imageIDs = await this.$q.all(promises);
            _.forEach(imageIDs, (imageID) => {
                if (imageID) {
                    this.images.push(this.getImageModel(imageID));
                }
            }, 0);
            if (_.size(failImages) === 0) {
                this.notificationService.showSuccessMessage();
            } else {
                this.showFail(failImages);
            }
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }

        this.waiting = false;
        this.uploadedImages = null;
    }

    public deleteImage = (image: IProductImage) => {
        this.images = _.reject(this.images, (item) => {
            return item.id === image.id;
        });
        this.deleteNoServerImage(image.id);
    }

    public close = () => {
        _.forEach(this.images, (image) => {
            this.deleteNoServerImage(image.id);
        });
    }

    private deleteNoServerImage = async (id: string) => {
        const imageID = id;
        if (!(imageID) || _.contains(this.serverImagesId, imageID)) {
            return;
        }
        try {
            await this.productService.deleteImage(imageID);
        } catch (error) {
            console.warn(error + ' image with id ' + imageID + ' is not removed');
        }

    }

    private emptyErrorImage(image: IImgFileModel) {
        return image.error == null || image.error === '';
    }

    private showFail = (failImages: IImgFileModel[]) => {
        this.notificationService.clearAll();
        if (_.size(failImages) === 0) {
            return;
        }
        let li = '';
        _.forEach(failImages, (image) => {
            li += '<li>' + image.name + '</li>';
        });
        const ul = '<ul class="pl15">' + li + '</ul>';
        this.popupService.alert({
            title: this.$translate.instant('cant_upload_photos') || 'Can\'t upload photos',
            content: `<p>${this.$translate.instant('cant_upload_photos_description')}</p>` + ul
        }).catch(() => { return; });
    }

    private getImageModel = (id: string): IProductImage => {
        return {
            id,
            url: this.productService.getImageUrl(id)
        };
    }

    private updateModel = () => {
        this.currentImagesId = _.pluck(this.images, 'id');
        if (_.isFunction(this.callbackUpdate)) {
            this.callbackUpdate();
        }
    }

    private init = () => {
        this.uploadedImages = null;
        this.images = [];
        this.currentImagesId = this.currentImagesId ? this.currentImagesId : [];
        this.serverImagesId = this.serverImagesId ? this.serverImagesId : [];

        if (_.isArray(this.currentImagesId)) {
            _.forEach(this.currentImagesId, (id) => {
                this.images.push(this.getImageModel(id));
            });
        }
    }
}

angular.module('naut').component('choiceProductImages', {
    template: ['$attrs', ($attrs: ng.IAttributes) => {
        return _.isUndefined($attrs.wizard) ? require('./choice-product-images-advanced.component.html') : require('./choice-product-images-wizard.component.html');
    }],
    controller: ChoiceProductImagesComponent,
    controllerAs: 'vm',
    bindings: {
        currentImagesId: '=',
        serverImagesId: '=',
        callbackUpdate: '&?',
        imageInputId: '='
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/choiceProductImages/choiceProductImages.component.ts